import React, { useMemo, useState } from 'react';
import WalletCard from '../../../../../../components/WalletCard/WalletCard';
import flexDollarA from '../../../../../../assets/icons/flexDollarA.svg';
import NoData from '../../../../../../components/NoData/NoData';
import dayjs from 'dayjs';
import failureIcon from '../../../../../../assets/icons/failureIcon.svg';
import successIcon from '../../../../../../assets/icons/succesIcon.svg';
import { formatCoinNetwork, formatToDollar } from '../../../../../../helpers/utils';
import ModalDeleteTransaction from '../../../../../../components/Modals/ModalDeleteTransaction';
import ModalUpdateTransactionMemo from '../../../../../../components/Modals/ModalUpdateTransactionMemo';
import ModalTransactionSearch from '../../../../../../components/Modals/ModalTransactionSearch';
import InterestBreakdown from '../../../../../../components/InterestBreakdown/InterestBreakdown';
import FlexDollarTransactionDetails from '../../../../../../components/NewSideSheet/FlexDollarTransactionDetails';
import { Loader } from '@piggytechng/component-library';
import useFlexDollar from '../../../../../../hooks/useFlexDollar';
import { useNavigate, useParams } from 'react-router-dom';
import useTransaction from '../../../../../../hooks/useTransaction';
import { AppliedTransactionSearch, WalletAddress } from '../../../../../../types';

const index = () => {
  const [showWalletBalance] = useState(true);
  const navigate = useNavigate();
  const params = useParams();
  const id = params.id as string;

  const [show, setShow] = useState(false);
  const [trDetails, setTrDetails] = useState<any>(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedTransactionRef, setSelectedTransactionRef] = useState<string>(''); // eslint-disable-line @typescript-eslint/no-unused-vars
  const [showUpdateMemoModal, setShowUpdateMemoModal] = useState(false);
  const [selectedTransactionForMemo] = useState<{ reference: string; memo: string }>({
    // eslint-disable-line @typescript-eslint/no-unused-vars
    reference: '',
    memo: '',
  });

  const {
    flexDollarBalance,
    flexDollarTransactionQ,
    flexDollarRate,
    isLoadingFlexDollarTransactions,
    refetchFlexDollarTransactions,
    flexDollarAccountNumber,
    searchFlexDollarTransactions,
    clearFlexDollarSearch,
    searchedTransactions,
    isSearching,
  } = useFlexDollar();

  const { deleteTransaction, updateTransactionMemo, isLoading: isTransactionLoading } = useTransaction();

  const [showSearchModal, setShowSearchModal] = useState(false);
  const [appliedSearch, setAppliedSearch] = useState<AppliedTransactionSearch | null>(null);
  const [activeHistoryTab, setActiveHistoryTab] = useState<'wallet' | 'interest'>('wallet');

  const transactionsToShow = searchedTransactions ?? flexDollarTransactionQ?.slice(0, 5);

  const handleApplySearch = (filter: string, value: string, display: string) => {
    setAppliedSearch({ filter, query: value, display });
    searchFlexDollarTransactions(value, filter);
    setShowSearchModal(false);
  };

  const handleResetSearch = () => {
    setAppliedSearch(null);
    clearFlexDollarSearch();
  };

  // const [showDropdown, setShowDropdown] = useState({
  //   index: -1,
  //   show: false,
  // });

  // const dropdownRef = useRef(null);
  // const actionRef = useRef(null);
  // useOutsideClick(dropdownRef, setShowDropdown, actionRef);

  const walletKey = 'flexdollar';

  const depositAddresses = useMemo<WalletAddress[]>(() => {
    const list = flexDollarAccountNumber?.depositAddresses;
    const source = Array.isArray(list) && list.length ? list : [];
    return source.map((addr: any) => ({
      ...addr,
      label: `[${formatCoinNetwork(addr.currency, addr.network)}]`,
    }));
  }, [flexDollarAccountNumber]);

  const walletCardsData = useMemo(() => {
    const baseCards = [
      {
        title: 'Flex Dollar Balance:',
        balanceKey: flexDollarBalance ?? 0,
        cardId: 'hm-card',
        image: flexDollarA,
        isActive: true,
        isOpenSideSheet: false,
        isDollar: true,
      },
    ];

    const addressCards = [
      {
        title: depositAddresses.length ? depositAddresses[0].label : 'Address',
        cardId: 'fd-address-card',
        isActive: true,
        isBalance: false,
        isText: true,
        text: depositAddresses.length ? depositAddresses[0].addressCode : 'None',
        isAddressCard: true,
        addresses: depositAddresses,
      },
    ];

    const nubanCards = flexDollarAccountNumber?.accountNumber
      ? [
          {
            title: `Account Number - ${flexDollarAccountNumber.bankName ?? ''}`,
            cardId: 'fd-acc-card',
            image: flexDollarA,
            isActive: true,
            isBalance: false,
            isText: true,
            text: String(flexDollarAccountNumber.accountNumber),
          },
        ]
      : [];

    return [...baseCards, ...addressCards, ...nubanCards];
  }, [flexDollarBalance, flexDollarAccountNumber, depositAddresses]);

  // const handleDeleteTransaction = (reference: string) => {
  //   setSelectedTransactionRef(reference);
  //   setShowDeleteModal(true);
  // };

  const handleDeleteSuccess = () => {
    refetchFlexDollarTransactions();
  };

  // const handleUpdateMemo = (reference: string, currentMemo: string) => {
  //   setSelectedTransactionForMemo({ reference, memo: currentMemo });
  //   setShowUpdateMemoModal(true);
  // };

  const handleUpdateMemoSuccess = () => {
    refetchFlexDollarTransactions();
  };

  const handleShowTransactionsDetails = (data: any) => {
    setTrDetails(data);
    setShow(true);
  };

  // const getDropdownArray = (reference: string, currentMemo: string) => [
  //   {
  //     icon: updateMemo,
  //     text: 'Update memo',
  //     fn: () => handleUpdateMemo(reference, currentMemo),
  //   },
  //   {
  //     icon: updateMemo,
  //     text: 'Fix transaction',
  //     fn: () => {},
  //   },
  //   {
  //     icon: updateMemo,
  //     text: 'Delete transaction',
  //     fn: () => handleDeleteTransaction(reference),
  //   },
  // ];

  // const handleShowDropdown = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, i: number) => {
  //   e.stopPropagation();
  //   if (i === showDropdown.index) {
  //     setShowDropdown({ ...showDropdown, show: false, index: -1 });
  //   } else {
  //     setShowDropdown({ ...showDropdown, show: true, index: i });
  //   }
  // };

  return (
    <>
      <div>
        <div className="flexdollar-rate-badge">
          <span className="flexdollar-rate-badge__dot" aria-hidden />
          <span className="flexdollar-rate-badge__title">Exchange rate</span>
          <span className="flexdollar-rate-badge__value">
            {flexDollarRate?.dollarToNairaRate ? `$1 = ₦${flexDollarRate.dollarToNairaRate}` : '—'}
          </span>
        </div>
        <div className="cards-container flex--2">
          {walletCardsData.map((item: any, i: any) => (
            <WalletCard
              key={i}
              {...item}
              showBalance={showWalletBalance}
              balance={item.balanceKey}
              // HMAccounts={houseMoneyDetails?.nubans.filter((account: HmNuban) => !account.deleted)}
              isAccCardAction={item.isAccCardAction}
              walletKey={walletKey}
            />
          ))}
        </div>
        <div className="wallets-details">
          <div className="history-tab-switch flexdollar">
            <span
              className={`history-pill${activeHistoryTab === 'wallet' ? ' active' : ''}`}
              onClick={() => setActiveHistoryTab('wallet')}
            >
              Wallet History
            </span>
            <span
              className={`history-pill${activeHistoryTab === 'interest' ? ' active' : ''}`}
              onClick={() => setActiveHistoryTab('interest')}
            >
              Interest Breakdown
            </span>
            {activeHistoryTab === 'wallet' && (
              <p className="view-all-g flex-dollar" onClick={() => navigate(`/flexdollar-transactions/${id}`)}>
                View all
              </p>
            )}
          </div>
          {activeHistoryTab === 'wallet' && (
            <div className="customers-filter">
              <div className="input-field">
                <form action="" onSubmit={(e) => e.preventDefault()}>
                  <input
                    type="text"
                    readOnly
                    placeholder="Search by reference, amount, memo, date"
                    value={
                      appliedSearch
                        ? `${appliedSearch.filter.charAt(0).toUpperCase() + appliedSearch.filter.slice(1)}: ${
                            appliedSearch.display
                          }`
                        : ''
                    }
                    onClick={() => setShowSearchModal(true)}
                  />
                </form>
              </div>
              <div className="query-filter" onClick={() => setShowSearchModal(true)}>
                <div>
                  <svg width="10" height="10" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M0.75 0.75H17.25M6.75 13.25H11.25M3.75 7H14.25"
                      stroke="#1E293B"
                      strokeWidth="1.5"
                      strokeLinecap="square"
                    />
                  </svg>
                </div>
                <div>Search</div>
              </div>
              <div className="query-filter" onClick={handleResetSearch}>
                <div></div>
                <div>Reset</div>
              </div>
            </div>
          )}
        </div>
        {activeHistoryTab === 'interest' ? (
          <InterestBreakdown walletName="flexdollar" />
        ) : isLoadingFlexDollarTransactions || isSearching ? (
          <div className="page-loader">
            <Loader color="#0F60D6" />
          </div>
        ) : (
          <>
            {transactionsToShow?.length ? (
              <div className="table-container flexnaira">
                <table className="table">
                  <thead className="table_head">
                    <tr>
                      <th className="icon">{''}</th>
                      <th className="date">Date</th>
                      <th className="amount">{`Amount ($)`}</th>
                      <th className="balance">{`Balance ($)`}</th>
                      <th className="memo">Memo</th>
                      <th className="trID">Transaction ID</th>
                    </tr>
                  </thead>

                  <tbody className="table-body">
                    {transactionsToShow?.map((txn: any) => (
                      <tr
                        key={txn.transactionId}
                        className="table-row"
                        onClick={() => handleShowTransactionsDetails(txn)}
                      >
                        <td className="icon">
                          <img
                            src={Number(txn.amount) >= 0 ? successIcon : failureIcon}
                            alt={Number(txn.amount) >= 0 ? 'credit' : 'debit'}
                          />
                        </td>
                        <td className="date">{dayjs(txn.date * 1000).format('D MMM YYYY | h:mm A')}</td>
                        <td className="amount">{formatToDollar(txn.amount)}</td>
                        <td className="balance">{formatToDollar(txn.balance)}</td>
                        <td className="memo">{txn.memo}</td>
                        <td className="trID">{txn.transactionId}</td>
                        {/* <div className="dropdown-container" ref={actionRef}>
                          <button onClick={(e) => handleShowDropdown(e, i)} className="pointer">
                            <LuMoreVertical color="#CBD5E1" size={25} />
                          </button>

                          {showDropdown.index === i && showDropdown.show && (
                            <div className="table-dropdown" ref={dropdownRef}>
                              <Dropdown data={getDropdownArray(txn.transactionId, txn.memo || '')} index={i} />
                            </div>
                          )}
                        </div> */}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <NoData message={'No transaction at the moment.'} />
            )}
          </>
        )}
      </div>

      <ModalTransactionSearch
        modalIsOpen={showSearchModal}
        setIsOpen={setShowSearchModal}
        onApply={handleApplySearch}
        onClear={handleResetSearch}
        isLoading={isSearching}
        initialFilter={appliedSearch?.filter}
        initialQuery={appliedSearch?.query}
      />

      <FlexDollarTransactionDetails
        show={show}
        data={trDetails}
        onClose={() => {
          setShow(false);
        }}
      />

      {selectedTransactionRef && (
        <ModalDeleteTransaction
          modalIsOpen={showDeleteModal}
          setIsOpen={setShowDeleteModal}
          reference={selectedTransactionRef}
          wallet="flexdollar"
          onDelete={deleteTransaction}
          onSuccess={handleDeleteSuccess}
          isLoading={isTransactionLoading}
        />
      )}
      {selectedTransactionForMemo.reference && (
        <ModalUpdateTransactionMemo
          modalIsOpen={showUpdateMemoModal}
          setIsOpen={setShowUpdateMemoModal}
          reference={selectedTransactionForMemo.reference}
          wallet="flexdollar"
          currentMemo={selectedTransactionForMemo.memo}
          onUpdate={updateTransactionMemo}
          onSuccess={handleUpdateMemoSuccess}
          isLoading={isTransactionLoading}
        />
      )}
    </>
  );
};

export default index;
